import React from 'react';
import Hero from '../components/Hero';
const AboutUs = () => {
  return <div className="w-full" data-id="element-77">
      {/* Hero Section */}
      <Hero title="Who We Are" subtitle="Combining precision with personalization for over a decade" data-id="element-78" />
      {/* Main Content */}
      <section className="py-16 md:py-24" data-id="element-79">
        <div className="container mx-auto px-4" data-id="element-80">
          <div className="max-w-4xl mx-auto" data-id="element-81">
            <h2 className="text-3xl font-serif mb-8 text-[#1a2542]" data-id="element-82">
              Our Approach
            </h2>
            <div className="prose prose-lg max-w-none" data-id="element-83">
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-84">
                At The Concierge Lawyering, we combine the precision of top-tier
                legal advisory with the personalized approach of a boutique
                consultancy. Headquartered in Lagos, and with a growing
                international footprint, our team brings over a decade of
                experience in guiding businesses, entrepreneurs, and investors
                through complex legal and regulatory landscapes.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-85">
                Our philosophy is simple: to make law work seamlessly for you.
                Whether navigating commercial deals, structuring global
                businesses, or ensuring compliance, we act not only as advisors
                but as partners in your growth.
              </p>
              <div className="my-12 p-8 bg-gray-50 rounded-lg border-l-4 border-[#c8a951]" data-id="element-86">
                <h3 className="text-xl font-serif mb-4 text-[#1a2542]" data-id="element-87">
                  Our Philosophy
                </h3>
                <p className="text-gray-700 italic" data-id="element-88">
                  "We believe in making law work seamlessly for our clients. We
                  don't just provide legal advice – we deliver solutions that
                  empower businesses to move forward with confidence."
                </p>
              </div>
              <h3 className="text-2xl font-serif mb-4 text-[#1a2542]" data-id="element-89">
                Global Reach, Local Expertise
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-90">
                With a foundation in Lagos and expanding international
                connections, we bridge legal systems and business cultures. Our
                expertise spans multiple jurisdictions, allowing us to provide
                comprehensive support for clients operating across borders.
              </p>
              <h3 className="text-2xl font-serif mb-4 text-[#1a2542]" data-id="element-91">
                Client-Centered Approach
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-92">
                We understand that every client's needs are unique. That's why
                we take the time to understand your business objectives, risk
                tolerance, and industry context before crafting legal strategies
                that align with your goals.
              </p>
              <h3 className="text-2xl font-serif mb-4 text-[#1a2542]" data-id="element-93">
                Decade of Excellence
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-94">
                Our team brings together over ten years of experience working
                with businesses of all sizes, from startups to multinational
                corporations. This depth of experience allows us to anticipate
                challenges and identify opportunities that others might miss.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-95">
        <div className="container mx-auto px-4" data-id="element-96">
          <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-97">
            <h2 className="text-3xl font-serif mb-4 text-[#1a2542]" data-id="element-98">
              Our Values
            </h2>
            <p className="text-lg text-gray-600" data-id="element-99">
              The principles that guide our practice and define our
              relationships with clients.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-100">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-101">
              <h3 className="text-xl font-serif mb-3 text-[#1a2542]" data-id="element-102">
                Excellence
              </h3>
              <p className="text-gray-600" data-id="element-103">
                We hold ourselves to the highest standards of legal expertise,
                service delivery, and ethical conduct.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-104">
              <h3 className="text-xl font-serif mb-3 text-[#1a2542]" data-id="element-105">
                Integrity
              </h3>
              <p className="text-gray-600" data-id="element-106">
                We operate with transparency, honesty, and a deep commitment to
                our clients' best interests.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-107">
              <h3 className="text-xl font-serif mb-3 text-[#1a2542]" data-id="element-108">
                Innovation
              </h3>
              <p className="text-gray-600" data-id="element-109">
                We continuously seek creative solutions to complex legal
                challenges in a rapidly evolving global landscape.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default AboutUs;